import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';

export const LoginViewStyled = styled(FlexContainer)`
  padding: 1.875rem;
  background: ${({ theme }) => theme.colors.primary.variant1};
`;

export const LogoWrapStyled = styled.div`
  display: flex;
  justify-content: center;
`;

export const LoginButtonStyled = styled(Button)`
  width: 300px;
  margin-top: 1.875rem;
  background-color: ${({ theme }) => theme.colors.secondary.variant2};
  color: ${({ theme }) => theme.colors.black};
  &:hover {
    color: ${({ theme }) => theme.colors.primary.variant1};
    background-color: ${({ theme }) => theme.colors.secondary.variant6};
  }
`;

export const ForgotPasswordButtonStyled = styled(Button)`
  margin-top: 0.25rem;
  padding: 0;
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;
